// Brands
import deliveryPassSmall from './asda-brand-delivery-pass-small.svg'
import deliveryPassLarge from './asda-brand-delivery-pass-large.svg'
import expressLarge from './asda-brand-express-large.svg'
import expressMedium from './asda-brand-express-medium.svg'
import expressSmall from './asda-brand-express-small.svg'
import expressSmallWhite from './asda-brand-express-small-white.svg'

export default {
  'delivery-pass-small': deliveryPassSmall,
  'delivery-pass-large': deliveryPassLarge,
  'express-large': expressLarge,
  'express-medium': expressMedium,
  'express-small': expressSmall,
  'express-small-white': expressSmallWhite,
}



// WEBPACK FOOTER //
// ./common/components/icon/brands/index.js